import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const React = require('react');
import { partition } from '../../../utils/array';
import { loanRulesNotice } from '../../../features/loanRulesNotice';
const byBranchName = (a, b)=>a.locationName.localeCompare(b.locationName);
export const CollectionItemAvailability = (param)=>{
    let { copies, className, id, preferredBranchId, medium } = param;
    if (!copies || copies.length === 0) return /*#__PURE__*/ _jsx("div", {
        className,
        id,
        children: /*#__PURE__*/ _jsx(OnRequest, {})
    });
    const sorted = [
        ...copies
    ].sort(byBranchName);
    const [favourite, others] = preferredBranchId ? partition(sorted, (c)=>c.locationId === preferredBranchId) : [
        [],
        sorted
    ];
    const [available, unavailable] = partition(others, (a)=>a.status === 'available');
    return /*#__PURE__*/ _jsxs("div", {
        className,
        id,
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "ci__section-title",
                children: "Beschikbaarheid"
            }),
            medium === 'book' && loanRulesNotice() === 'on' && /*#__PURE__*/ _jsxs("div", {
                className: "ci__availability-warning",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        children: "Vanwege de grote populariteit van de boeken voor Sinterklaas en kerst, hanteren we afwijkende regels rondom deze collectie, zodat zoveel mogelijk lezers ervan kunnen genieten:"
                    }),
                    /*#__PURE__*/ _jsxs("ul", {
                        children: [
                            /*#__PURE__*/ _jsx("li", {
                                children: "Per pasje mag je maximaal twee kerstboeken en twee Sintboeken lenen, dus vier in totaal."
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: "De boeken kun je niet reserveren, maar alleen ter plekke lenen in de bibliotheek."
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: "Reserveer je toch? Dan wordt het boek geleverd door een bibliotheek buiten ons werkgebied. In dat geval zitten er kosten verbonden aan je reservering."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("section", {
                className: `ci__availability-section`,
                children: /*#__PURE__*/ _jsxs("ul", {
                    children: [
                        /*#__PURE__*/ _jsx(AvailabilitySection, {
                            copies: favourite,
                            preferredBranchId: preferredBranchId
                        }),
                        /*#__PURE__*/ _jsx(AvailabilitySection, {
                            copies: available
                        }),
                        /*#__PURE__*/ _jsx(AvailabilitySection, {
                            copies: unavailable
                        })
                    ]
                })
            })
        ]
    });
};
const AvailabilitySection = (param)=>{
    let { copies, preferredBranchId } = param;
    return copies.length == 0 ? /*#__PURE__*/ _jsx(_Fragment, {}) : /*#__PURE__*/ _jsx(_Fragment, {
        children: copies.map((a, idx)=>{
            const available = a.status === 'available';
            const isPreferred = !!preferredBranchId && a.locationId === preferredBranchId;
            return /*#__PURE__*/ _jsxs("li", {
                className: `ci__availability--item ${isPreferred ? ' ci__availability--item-preferred' : ''}`,
                children: [
                    /*#__PURE__*/ _jsxs("header", {
                        className: "ci__availability--header",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx("h3", {
                                        className: "ci__availability-location-name title--s",
                                        children: a.locationName
                                    }),
                                    isPreferred && /*#__PURE__*/ _jsx("span", {
                                        className: "c-item__label text--xs",
                                        children: "Mijn bieb"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: `c-item__availability text--s c-item__availability--${a.status}`,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "c-item__availability--dot"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "c-item__availability--label",
                                        children: available ? 'Aanwezig' : 'Uitgeleend'
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "ci__availability-location-details",
                        children: a.locationDetails
                    })
                ]
            }, `available-${a.locationId}-${a.locationName}-${idx}`);
        })
    });
};
const OnRequest = ()=>/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "ci__section-title",
                children: "Beschikbaarheid"
            }),
            /*#__PURE__*/ _jsx("section", {
                className: `ci__availability-section`,
                children: "Dit item hebben we niet in onze collectie, maar je kan het wel aanvragen. We halen het dan voor je op bij een andere bibliotheek in Nederland. Let op: hier kunnen extra kosten aan verbonden zijn."
            })
        ]
    });
